import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/payments/payment-plans_/create')({
  staticData: {
    team: 'payments',
  },
});
